import React from 'react';
import { FormattedNumber } from 'react-intl';
import Icon from '../../components/Icon';
import PropTypes from 'prop-types';

var Balance = function Balance(_ref) {
  var wallet = _ref.wallet,
      user = _ref.user,
      refresh = _ref.refresh;

  var totalBalance = wallet.Total.Balance;
  var currency = user.Currency && user.Currency;

  return React.createElement(
    'div',
    { className: 'profile-value' },
    React.createElement(FormattedNumber, {
      value: totalBalance,
      currency: currency,
      style: 'currency'
    }),
    React.createElement(
      'a',
      { onClick: refresh },
      React.createElement(Icon, { icon: 'refresh' })
    )
  );
};

Balance.propTypes = {
  /** Wallet data object */
  wallet: PropTypes.object,
  /** user data object */
  user: PropTypes.object,
  /** Function that updates/refreshes the wallet */
  refresh: PropTypes.func
};

Balance.defaultProps = {
  wallet: { Total: { Balance: 0 } },
  user: {},
  refresh: function refresh() {
    return false;
  }
};

export default Balance;